import React, { useEffect, useState } from 'react';
import {
    PaymentRequestButtonElement,
    Elements, PaymentElement,
    LinkAuthenticationElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import PaymentForm from '../../pages/components/donation-widget/payment-form';
import axios from 'axios';
import { INITIATE_QUICK_PAYMENT } from '../../constants/endpoints';
import { useFormContext } from 'react-hook-form';
import calculateCCAfterFee, { calculateFeePercentage } from '../../utils/stripe-payment-fee.util';
import { CURRENCY_CODE_SIGN_MAPPING } from '../../constants/currency-code-sign.constant';
import './payment-request-form.scss';

const PaymentRequestForm = (props) => {

    const stripe = useStripe();
    const [paymentRequest, setPaymentRequest] = useState(null);
    const {register, watch, setValue, getValues} = useFormContext();
    const fieldsWatcher = watch();

    const returnSelectedAmount = () => {
        return parseFloat(props?.amount);   
    }

    const [stripeAmount, setStripeAmount] = useState(0);
    useEffect(() => {
        setPaymentRequest(null);
    }, [stripe, props?.campaignDetail, props?.selectedDonationType, props?.amount]);

    useEffect(() => {
        if(!paymentRequest){
            props?.setStripeButtonElementLoader(true);
            if (stripe && props?.campaignDetail && props?.selectedDonationType) {
                let amount = returnSelectedAmount();
                const finalAmount =
                ((props?.campaignDetail?.donation_amount?.ask_donors_cover_fee_default
                    ? Math.round(parseFloat(calculateCCAfterFee((amount)) * 100)) : (Math.round(amount * 100)) ))
                
                  if(!isNaN(finalAmount)){
                    setStripeAmount(finalAmount)
                  };
                const paymentRequestObject = stripe.paymentRequest({
                    country: props?.campaignDetail?.country?.toLowerCase() === 'usa' ? 'US' : props?.campaignDetail?.country,
                    currency: props?.campaignDetail?.currency,
                    total: {
                        label: 'Total',
                        amount: !isNaN(finalAmount) ? finalAmount : 0
                    },
                    requestPayerName: true,
                    requestPayerEmail: true
                });
    
                const donationType = props.selectedDonationType;
                //checking if apple pay or google pay is available or not 
                paymentRequestObject.canMakePayment().then((response) => {
                    props?.setStripeButtonElementLoader(false);
                    if (response) {
                        props?.setPaymentFlow(true);
                        setPaymentRequest(paymentRequestObject);
    
                        paymentRequestObject.on('paymentmethod', async (ev) => {
                            //constructing personal info object from google and apple pay integration
                            let userInfo = {
                                first_name: ev.payerName.split(' ')[0],
                                last_name: ev.payerName.split(' ')[1],
                                email: ev.payerEmail,
                                address:ev.paymentMethod.billing_details.address.line1,
                                address_2: ev.paymentMethod.billing_details.address.line2,
                                city:ev.paymentMethod.billing_details.address.city,
                                state_province:ev.paymentMethod.billing_details.address.state,
                                postal_code:ev.paymentMethod.billing_details.address.postal_code,
                                country:ev.paymentMethod.billing_details.address.country,
                                payment_method_id: ev.paymentMethod.id,
                                donation_type: donationType
                            }
                            
                            const donationPayload = props?.returnDonationPayload(userInfo);
    
                            try {
                                const res = await axios.post(INITIATE_QUICK_PAYMENT, donationPayload);
                                const clientSecret = res?.data?.response?.client_secret;
                                if(clientSecret){
                                    // Confirm the PaymentIntent without handling potential next actions (yet).
                                const {paymentIntent, error: confirmError} = await stripe.confirmCardPayment(
                                    clientSecret,
                                  {payment_method: ev.paymentMethod.id},
                                  {handleActions: false}
                                );
        
                                if (confirmError) {
                                    alert(JSON.stringify(confirmError));
                                  // Report to the browser that the payment failed, prompting it to
                                  // re-show the payment interface, or show an error message and close
                                  // the payment interface.
                                  ev.complete('fail');
                                } else {
                                  // Report to the browser that the confirmation was successful, prompting
                                  // it to close the browser payment method collection interface.
                                  ev.complete('success');
                                  props?.onPaymentSuccess("Payment successful thank you for your kind donations.");
                                  // Check if the PaymentIntent requires any actions and if so let Stripe.js
                                  // handle the flow. If using an API version older than "2019-02-11"
                                  // instead check for: `paymentIntent.status === "requires_source_action"`.
                                  if (paymentIntent.status === "requires_action") {
                                    // Let Stripe.js handle the rest of the payment flow.
                                    const {error} = await stripe.confirmCardPayment( clientSecret );
                                    if (error) {
                                        alert(JSON.stringify(error));
                                      // The payment failed -- ask your customer for a new payment method.
                                    } else {
                                        props?.onPaymentSuccess("Payment successful thank you for your kind donations.");
                                      // The payment has succeeded.
                                    }
                                  } else {
                                    props?.onPaymentSuccess("Payment successful thank you for your kind donations.");
                                    // The payment has succeeded.
                                  }
                                }
                            }else{
                                alert(res?.data?.response);
                            }
                            } catch (error) {
                                alert('Unable to complete your request, try again later.');
                            }
                          });
                    }else{
                        // props?.setPaymentFlow('info');
                        props?.setPaymentFlow(false);
                    }
                }).catch((error) => {
                    props?.setStripeButtonElementLoader(false);
                });
            }
    
            // if(props?.campaignDetail?.donation_amount?.ask_donors_cover_fee_default){
            //     setValue('cover_processing_fee',true);
            // }else{
            //     setValue('cover_processing_fee',false);
            // }
        }
    },[stripe, paymentRequest, props?.campaignDetail, props?.selectedDonationType])

    // useEffect(() => {
    //     let amount = returnSelectedAmount();
    //     if (paymentRequest && amount >= 0) {
    //         const finalAmount =
    //             ((props?.campaignDetail?.donation_amount?.ask_donors_cover_fee_default
    //                 ? Math.round(parseFloat(calculateCCAfterFee((amount)) * 100)) : (Math.round(amount * 100))))
    //         paymentRequest.update({
    //             country: 'US',
    //             currency: 'usd',
    //             total: {
    //                 label: 'Total',
    //                 amount: !isNaN(finalAmount) ? finalAmount : 0
    //             },
    //         });
    //     }
    // },[getValues()?.selected_amount, getValues()?.custom_amount, props?.amount]);

    const updatePaymentRequest = (event) => {
        const finalAmount = ((event?.target?.checked
            ? Math.round(parseFloat(calculateCCAfterFee((props?.amount)) * 100)) : (Math.round(props?.amount * 100)) ))
        if(paymentRequest){
            setStripeAmount(finalAmount);
            paymentRequest.update({
                country: props?.campaignDetail?.country?.toLowerCase() === 'usa' ? 'US' : props?.campaignDetail?.country,
                currency: props?.campaignDetail?.currency,
                total: {
                    label: 'Total',
                    amount: finalAmount
                },
            });
        }
    }

    // useEffect(() => {
    //     if(props?.amount && paymentRequest){
    //         const finalAmount =
    //         ((props?.campaignDetail?.donation_amount?.ask_donors_cover_fee_default
    //             ? Math.round(parseFloat(calculateCCAfterFee((props?.amount)) * 100)) : (Math.round(props?.amount * 100)) ))
    //             paymentRequest.update({
    //                 country:'US',
    //                 currency: 'usd',
    //                 total: {
    //                     label: 'Total',
    //                     amount: finalAmount
    //                 },
    //             });

    //             setStripeAmount(finalAmount);
    //     }
    // }, [props?.amount])

    useEffect(() => {
        if(props?.formStep === 'request_button'){
            const isDefaultChecked = !!props?.campaignDetail?.donation_amount?.ask_donors_cover_fee_default;
            setValue('cover_processing_fee', isDefaultChecked);
            updatePaymentRequest({target:{checked: isDefaultChecked }});
        }
    }, [props?.formStep, props?.campaignDetail])

    return (
        <>
            {
                paymentRequest ?
                    <div className=''>        
                        {
                            (props?.campaignDetail?.donation_amount?.ask_donors_cover_fee &&
                                props?.formStep === 'request_button'
                                ) ?
                                <div className='mt-2 mb-2 text-start'>
                                    <label className="fee-row" style={{ cursor: 'pointer', gap: '8px' }}>
                                        <input 
                                            id="cover_processing_fee"
                                            defaultChecked={props?.campaignDetail?.donation_amount?.ask_donors_cover_fee_default ? true : false} 
                                            {...register('cover_processing_fee', {
                                                onChange: ((e) => {
                                                    if(props?.calculateStripeFee){
                                                        props?.calculateStripeFee(e)
                                                    }
                                                    updatePaymentRequest(e);
                                                })
                                            })} 
                                            className="recurring-form-check" 
                                            type="checkbox"
                                            style={{ '--checkbox-color': props?.productDetail?.primary_color || props?.campaignDetail?.primary_color || '#155C4E', marginTop: '-3px' }}
                                        />
                                        <div className="fee-text" id="feeLabel">
                                            {props?.campaignDetail?.donation_amount?.change_label_to_pay === true ? (
                                                <>
                                                    <strong>
                                                        {CURRENCY_CODE_SIGN_MAPPING[props?.productDetail?.currency || props?.campaignDetail?.currency]}{" "}
                                                        {calculateFeePercentage(props?.amount)}
                                                    </strong>{" "}
                                                    Cover Processing Fee
                                                </>
                                            ) : (
                                                <>
                                                    Cover the{" "}
                                                    <strong>
                                                        {CURRENCY_CODE_SIGN_MAPPING[props?.productDetail?.currency || props?.campaignDetail?.currency]}{" "}
                                                        {calculateFeePercentage(props?.amount)} processing fee
                                                    </strong>{" "}
                                                    so 100% of your donation goes to the masjid
                                                </>
                                            )}
                                        </div>
                                    </label>
                                </div> : ''
                        }
                        <hr className='full-divider my-0 mt-4' style={{ marginLeft: '-35px', width: 'calc(100% + 72px)' }} />
                        <p className='section-label mt-3'>Choose Payment Method</p>
                        <div className="mt-2 gpay-button">
                            <PaymentRequestButtonElement options={{ paymentRequest }} /> 
                        </div>
                        <div className="divider-text">or</div>
                        <div className="pay-method-row">
                            <button
                                type="button"
                                className="pay-method-btn"
                                style={{ '--hover-border-color': props?.productDetail?.primary_color || props?.campaignDetail?.primary_color || '#155C4E' }}
                                onClick={() => props?.setPaymentFlow ? props.setPaymentFlow('info') : null}
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
                                    <rect x="1.5" y="3.5" width="13" height="9" rx="1.5"/>
                                    <line x1="1.5" y1="6.5" x2="14.5" y2="6.5"/>
                                </svg>
                                Credit / Debit Card
                            </button>

                            {
                                (props?.productDetail?.enable_ach || props?.campaignDetail?.enable_ach) &&
                                <button
                                    type="button"
                                    className="pay-method-btn"
                                    style={{ '--hover-border-color': props?.productDetail?.primary_color || props?.campaignDetail?.primary_color || '#155C4E' }}
                                    onClick={() => props?.setPaymentFlow ? props.setPaymentFlow('info') : null}
                                >
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.3">
                                        <rect x="1.5" y="4" width="13" height="9" rx="1.5"/>
                                        <path d="M4 7.5h8M4 10h5"/>
                                    </svg>
                                    Bank (ACH)
                                </button>
                            }
                        </div>
                    </div>
                    : ''
            }
        </>
    );
}

export default PaymentRequestForm;